// src/App.tsx
import { AuthProvider } from '@/contexts/AuthContext';
import { ProtectedRoute } from '@/components/auth/ProtectedRoute';
import { Layout } from '@/components/layout/Layout';
import { DashboardView } from '@/views/DashboardView';
import { PersonalView } from '@/views/PersonalView';
import { LeaderboardView } from '@/views/LeaderboardView';
import { AchievementsView } from '@/views/AchievementsView';
import { AnalyticsView } from '@/views/AnalyticsView';

function App() {
  return (
    <AuthProvider>
      <ProtectedRoute>
        <Layout>
          {(activeView) => {
            switch (activeView) {
              case 'dashboard':
                return <DashboardView />;
              case 'personal':
                return <PersonalView />;
              case 'leaderboard':
                return <LeaderboardView />;
              case 'achievements':
                return <AchievementsView />;
              case 'analytics':
                return <AnalyticsView />;
              default:
                return <DashboardView />;
            }
          }}
        </Layout>
      </ProtectedRoute>
    </AuthProvider>
  );
}

export default App;

